var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600037 12.7886C0.600037 19.416 5.97262 24.7886 12.6 24.7886C19.2275 24.7886 24.6 19.416 24.6 12.7886C24.6 6.16116 19.2275 0.788574 12.6 0.788574C5.97262 0.788574 0.600037 6.16116 0.600037 12.7886ZM10.4 18.2886L10.6042 15.2297L10.604 15.2296L16.1685 10.2081C16.4127 9.99133 16.1152 9.88564 15.791 10.0822L8.92368 14.4147L5.95738 13.4889C5.31679 13.2928 5.31219 12.8526 6.1012 12.5361L17.6602 8.079C18.1881 7.83932 18.6977 8.2058 18.4961 9.01382L16.5276 18.2901C16.3902 18.9493 15.9919 19.107 15.44 18.8025L12.4414 16.587L11 17.9886C10.9955 17.993 10.991 17.9974 10.9865 18.0018C10.8253 18.1587 10.6919 18.2886 10.4 18.2886Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.ccf36dca23709ce0903779495a954515.svg";
export { ForwardRef as ReactComponent };